// @flow
import { v4 as uuidv4 } from "uuid";
import * as types from "./types";
import { apiService } from "../../services/APIService";
import { logger } from "../../modules/Logger";


const loadMasterCoursesSuccess = (plan) => ({
  type: types.LOAD_MASTER_COURSE_SUCCESS,
  payload: plan,
});
const loadMasterCoursesFailed = (error) => ({
  type: types.LOAD_MASTER_COURSE_FAILED,
  payload: error,
});


export const fetchMasterCourses = () => async (dispatch: Function) => {
  try {
    const masterCourses = await apiService.fetchMasterCourses();
    dispatch(loadMasterCoursesSuccess(masterCourses));
  } catch (error) {
    dispatch(loadMasterCoursesFailed(error));
    throw new Error("Error fetching Master Courses from API");
  }
};
